"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import external dependencies
require("bootstrap");
const jquery_1 = __importDefault(require("jquery"));
const about_1 = __importDefault(require("./routes/about"));
const backendEbooksAdd_1 = require("./routes/backend/backendEbooksAdd");
const common_1 = __importDefault(require("./routes/common"));
const ebooks_detailed_1 = require("./routes/ebooks-detailed");
const home_1 = __importDefault(require("./routes/home"));
// import local dependencies
const router_1 = __importDefault(require("./util/router"));
/** Populate Router instance with DOM routes */
const routes = new router_1.default({
    // All pages
    common: common_1.default,
    // Home page
    home: home_1.default,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs: about_1.default,
    ebooksDetailed: ebooks_detailed_1.ebooksDetailed,
    backendEbooksAdd: backendEbooksAdd_1.backendEbooksAdd,
});
// Load Events
(0, jquery_1.default)(() => routes.loadEvents());
